<template>
	<div>
		<ul>
			<li>
				<router-link :to="{ name: 'vehicle-detail' }"
					>Detail</router-link
				>
			</li>
			<li>
				<router-link :to="{ name: 'vehicle-events' }"
					>Events</router-link
				>
			</li>
			<li>
				<router-link :to="{ name: 'vehicle-po-history' }"
					>Purchase Orders</router-link
				>
			</li>
			<li>
				<router-link :to="{ name: 'vehicle-ro-history' }"
					>Repair Orders</router-link
				>
			</li>
			<li>
				<router-link :to="{ name: 'vehicle-warranty' }"
					>Warranty</router-link
				>
			</li>
		</ul>
		<div>
			<VehicleHeader />
		</div>
		<router-view :vehicle="vehicleResult"></router-view>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VehicleHeader from './vehicle-header-view';
import { VehicleLog } from '@/constants/permissions';
import { Read } from '@/constants/permission-rights';
import Permission from '@/classes/permission';
import pageMixin from '@/mixins/page-mixin';

export default {
	name: 'VehiclePage',
	mixins: [pageMixin],
	metaInfo: {
		title: 'Vehicle'
	},
	async created() {
		if (this.id) {
			await this.getVehicleAction(this.id);
			this.hidePageLoader();
		}
	},
	components: {
		VehicleHeader
	},
	props: {
		id: {
			type: Number,
			default: 0
		},
		requiredPermissions: {
			type: Function,
			default: () => {
				//custom auth function that returns what permissions you need
				return [new Permission(VehicleLog, Read)];
			}
		}
	},
	computed: {
		...mapGetters('vehicle', ['vehicleResult'])
	},
	methods: {
		...mapActions('vehicle', ['getVehicleAction', 'saveVehicleAction'])
	}
};
</script>

<style lang="scss" scoped></style>
